import { render, staticRenderFns } from "./InfoTablaBasica.vue?vue&type=template&id=3e9d8db9&"
import script from "./InfoTablaBasica.vue?vue&type=script&lang=js&"
export * from "./InfoTablaBasica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e9d8db9')) {
      api.createRecord('3e9d8db9', component.options)
    } else {
      api.reload('3e9d8db9', component.options)
    }
    module.hot.accept("./InfoTablaBasica.vue?vue&type=template&id=3e9d8db9&", function () {
      api.rerender('3e9d8db9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/_vue/componentes/tabla/InfoTablaBasica.vue"
export default component.exports